module.exports = __webpack_public_path__ + "static/img/898.4edf29b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/898.jpg
// module id = 39
// module chunks = 1